export enum ComparisonType {
  Equals = 0,
  Contains,
  LessThan,
  LessThanOrEqual,
  GreaterThan,
  GreaterThanOrEqual
}
